"use client";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Mail } from "lucide-react";

// Define simpler props with only necessary fields
interface WelcomeEmailButtonProps {
  user: {
    email: string;
    first_name: string | null;
  };
  variant?: "default" | "table";
}

export function WelcomeEmailButton({
  user,
  variant = "default",
}: WelcomeEmailButtonProps) {
  const handleSendWelcomeEmail = () => {
    const firstName = user.first_name || "there";
    const emailBody = `${firstName},

Thanks for checking out Pluggo. Curious, did you find the leads useful?

If there's anything we can do to improve the experience, let us know.

Cheers,
Giulio
Founder, Pluggo
https://pluggo.ai`;

    const mailtoUrl = `mailto:${user.email}?subject=${encodeURIComponent(
      `${firstName} - welcome to Pluggo`,
    )}&body=${encodeURIComponent(emailBody)}`;

    window.open(mailtoUrl, "_blank");
  };

  if (variant === "table") {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="text-green-600 hover:text-green-700"
              onClick={handleSendWelcomeEmail}
            >
              <Mail className="h-4 w-4" />
              <span className="sr-only">Send Welcome Email</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Send Welcome Email</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      className="flex items-center gap-2"
      onClick={handleSendWelcomeEmail}
    >
      <Mail className="h-4 w-4" />
      Send Welcome Email
    </Button>
  );
}
